import { render, staticRenderFns } from "./modalVerbasRescisoriasBase.vue?vue&type=template&id=ee4c163c&scoped=true&"
import script from "./modalVerbasRescisoriasBase.vue?vue&type=script&lang=js&"
export * from "./modalVerbasRescisoriasBase.vue?vue&type=script&lang=js&"
import style0 from "./modalVerbasRescisoriasBase.vue?vue&type=style&index=0&id=ee4c163c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4c163c",
  null
  
)

export default component.exports